import axios from 'axios';

export default {
  getList(_, params) {
    return axios.get('Staff/GetList', { params });
  },
  reject(_, id) {
    return axios.get('Staff/Reject', { params: { id } });
  },
  approve(_, id) {
    return axios.get('Staff/Approve', { params: { id } });
  },
};
